import { Spin } from "antd";
import classnames from "classnames";
import PropTypes from "prop-types";
import { useStateContext } from "../../context/ContextProvider";

const FullScreenLoader = ({
  loaderColor,
  loadingText = "Loading, Please wait...",
  containerWidth,
}) => {
  const { appTheme } = useStateContext();

  return (
    <div className="fixed inset-0 z-50 w-full h-full flex items-center justify-center bg-white/40 backdrop-blur-sm">
      <div
        className={classnames(
          containerWidth ? `w-[${containerWidth}]` : "w-48",
          "h-max flex flex-col justify-center items-center text-center px-4 pt-4 pb-2 rounded-lg"
        )}
      >
        <Spin
          size="large"
          style={{
            color: loaderColor || appTheme.primaryDark,
          }}
        />
        <p className="text-gray-700 mt-2">{loadingText}</p>
      </div>
    </div>
  );
};

FullScreenLoader.propTypes = {
  loaderColor: PropTypes.string,
  loadingText: PropTypes.string,
  containerWidth: PropTypes.string,
};

export default FullScreenLoader;
